/**
 * 节点类型枚举
 * - name：环节名称及默认名称使用
 * - stepType： 后端交互时使用的步骤类型
 * - classType: 前端交互时使用的步骤类型及枚举类型
 */
export const PROCESS_NODE_TYPES = {
  START_STEP: {
    name: '项目启动',
    stepType: '0',
    classType: 'START_STEP'
  },
  START_ASSESS: {
    name: '评估型环节',
    stepType: '1',
    classType: 'START_ASSESS'
  },
  GOAL_SETTING: {
    name: '目标制定环节',
    stepType: '4',
    classType: 'GOAL_SETTING'
  },
  ANNULAR_INVITE: {
    name: '360°邀请环节',
    stepType: '5',
    classType: 'ANNULAR_INVITE'
  },
  ANNULAR_IDENTIFY: {
    name: '360°确认环节',
    stepType: '6',
    classType: 'ANNULAR_IDENTIFY'
  },
  CALIBRATION: {
    name: '绩效校准环节',
    stepType: '7',
    classType: 'CALIBRATION'
  },
  START_VIEW: {
    name: '绩效结果查看环节',
    stepType: '2',
    classType: 'START_VIEW'
  },
  COMMUNICATION_RESULT: {
    name: '结果沟通环节',
    stepType: '8',
    classType: 'COMMUNICATION_RESULT'
  },
  RESULT_REVIEW: {
    name: '结果复议环节',
    stepType: '10',
    classType: 'RESULT_REVIEW'
  },
  START_END: {
    name: '项目结束',
    stepType: '3',
    classType: 'START_END'
  }
}


/**
 * 节点类型以及枚举MAP版本
 *  - 后端与前端 | 数字与枚举值对照表
 *  - 示例；{ '0': PROCESS_NODE_TYPES['START_STEP'], ’1‘：xxxx }
 */
export const PROCESS_NODE_TYPES_MAP = (() => {
  return Object.keys(PROCESS_NODE_TYPES).reduce((obj, key) => {
    obj[PROCESS_NODE_TYPES[key].stepType] = PROCESS_NODE_TYPES[key]
    return obj
  }, {})
})()